import { INITIAL_STATE } from "../../constant";
import {
  getLatestPosts,
  getType,
  crawlData,
  createPost,
  getHighLightPosts,
  getPostDetail,
  getRelatedPosts,
  fetchHomePageData,
  searchPosts,
  updatePost,
  deletePost,
} from "../actions";

export default function postsReducers(state = INITIAL_STATE.posts, action) {
  switch (action.type) {
    case getType(fetchHomePageData.sendHomePageRequest):
      return {
        ...state,
        latest: [],
        highLight: [],
        promotionCodes: [],
        applications: [],
      };
    case getType(fetchHomePageData.getHomePageSuccess):
      return {
        ...state,
        isLoading: false,
        latest: action.payload.latest,
        highLight: action.payload.highLight,
        promotionCodes: action.payload.promotionCodes,
        applications: action.payload.applications,
      };
    case getType(fetchHomePageData.getHomePageFailure):
      return {
        ...state,
        isLoading: false,
      };
    /**
     * Search posts
     */
    case getType(searchPosts.sendSearchPostsRequest):
      return {
        ...state,
        latest: [],
        allPosts: action.payload.fetchMore ? state.allPosts : [],
        totalPosts: 0,
      };
    case getType(searchPosts.getSearchPostsSuccess):
      return {
        ...state,
        latest: action.payload.latest,
        allPosts: state.allPosts.concat(action.payload.allPosts),
        totalPosts: action.payload.totalPosts,
      };
    case getType(searchPosts.getSearchPostsFailure):
      return {
        ...state,
        isLoading: false,
      };
    /**
     * Get latest post
     */
    case getType(getLatestPosts.getPostsRequest): // case 'getPostsRequest'
      return {
        ...state,
        latest: [],
        isLoading: true,
      };
    case getType(getLatestPosts.getPostSuccess): // case 'getPostSuccess'
      return {
        ...state,
        isLoading: false,
        latest: action.payload
      };
    case getType(getLatestPosts.getPostFailure): // case 'getPostFailure'
      return {
        ...state,
        isLoading: false,
      };
    /**
     * Get related posts
     */
    case getType(getRelatedPosts.sendRelatedPostsRequest): // case 'getPostsRequest'
      return {
        ...state,
        allPosts: [],
        totalPosts: 0,
        isLoading: true,
      };
    case getType(getRelatedPosts.getRelatedPostsSuccess): // case 'getPostSuccess'
      return {
        ...state,
        isLoading: false,
        allPosts: action.payload.data,
        totalPosts: action.payload.total,
      };
    case getType(getRelatedPosts.getRelatedPostsFailure): // case 'getPostFailure'
      return {
        ...state,
        isLoading: false,
      };
    /**
     * Get highlight post
     */
    case getType(getHighLightPosts.sendRequest): // case 'getPostsRequest'
      return {
        ...state,
        highLight: [],
        isLoading: true,
      };
    case getType(getHighLightPosts.getSuccess): // case 'getPostSuccess'
      return {
        ...state,
        isLoading: false,
        highLight: action.payload
      };
    case getType(getHighLightPosts.getFailure): // case 'getPostFailure'
      return {
        ...state,
        isLoading: false,
      };
    /**
     * Get post detail
     */
    case getType(getPostDetail.sendPostDetailRequest): // case 'getPostsRequest'
      return {
        ...state,
        detail: {},
        latest: [],
        related: [],
        isLoading: true,
        isLoadingDetail: true,
      };
    case getType(getPostDetail.getPostDetailSuccess): // case 'getPostSuccess'
      return {
        ...state,
        isLoading: false,
        isLoadingDetail: false,
        detail: action.payload.detail,
        latest: action.payload.latest,
        related: action.payload.related,
      };
    case getType(getPostDetail.getPostDetailFailure): // case 'getPostFailure'
      return {
        ...state,
        isLoading: false,
        isLoadingDetail: false,
      };
    case getType(createPost.createPostRequest): // case 'getPostsRequest'
      return {
        ...state,
        isLoading: true,
      };
    case getType(createPost.createPostSuccess): // case 'getPostSuccess'
      return {
        ...state,
        isLoading: false,
        currentCreatedPost: action.payload
      };
    case getType(createPost.createPostFailure): // case 'getPostFailure'
      return {
        ...state,
        isLoading: false,
      };
    case getType(updatePost.updatePostRequest): // case 'getPostsRequest'
      return {
        ...state,
        isLoading: true,
      };
    case getType(updatePost.updatePostSuccess): // case 'getPostSuccess'
      return {
        ...state,
        isLoading: false,
        currentCreatedPost: action.payload
      };
    case getType(updatePost.updatePostFailure): // case 'getPostFailure'
      return {
        ...state,
        isLoading: false,
      };
    case getType(deletePost.deletePostRequest): // case 'getPostsRequest'
      return {
        ...state,
        isLoading: true,
      };
    case getType(deletePost.deletePostSuccess): // case 'getPostSuccess'
      return {
        ...state,
        isLoading: false,
        postDeleted: action.payload
      };
    case getType(deletePost.deletePostFailure): // case 'getPostFailure'
      return {
        ...state,
        isLoading: false,
      };
    case getType(crawlData.crawlDataRequest): // case 'getPostsRequest'
      return {
        ...state,
        isLoading: true,
      };
    case getType(crawlData.crawlDataSuccess): // case 'getPostSuccess'
      return {
        ...state,
        isLoading: false,
        dataCrawl: action.payload
      };
    case getType(crawlData.crawlDataFailure): // case 'getPostFailure'
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}